import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, Stack, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import AddReactionOutlinedIcon from '@mui/icons-material/AddReactionOutlined';

import CustomerTable from './CustomerTable';
import FormCustomer from './FormCustomer';
import Credit from '../credits/Credit';

const Customer = () => {
  const [openForm, setOpenForm] = useState(false);
  const [openCredit, setOpenCredit] = useState(false);
  const [action, setAction] = useState('');

  const [selectedCampaignId, setSelectedCampaignId] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [selectedGroup, setSelectedGroup] = useState(0);
  const [selectedCustomerType, setSelectedCustomerType] = useState(0);
  const [selectedDisbursementOffice, setSelectedDisbursementOffice] = useState(0);

  const [customer, setCustomer] = useState(null);
  const [credit, setCredit] = useState(null);

  const customers = useSelector((state) => state.customers.data);
  const status = useSelector((state) => state.dataTypes.data);
  const campaigns = useSelector((state) => state.campaign.data);
  const credits = useSelector((state) => state.credits.data);
  const groups = useSelector((state) => state.customerGroup.data);
  const customerType = useSelector((state) => state.customerType.data);
  const disbursementOffice = useSelector((state) => state.disbursementOffice.data);

  const filteredCustomers = useMemo(() => {

    const filtered = customers.filter((c) => {
      const matchCampaign = selectedCampaignId === 0 || c.id_campaign === selectedCampaignId;
      const matchCreditStatus = selectedStatus === 0 || c.status_id === selectedStatus;
      const matchGroup = selectedGroup === 0 || c.customer_group_id === selectedGroup;
      const matchCustomerType = selectedCustomerType === 0 || c.customer_type_id === selectedCustomerType;
      const matchDisbursementOffice = selectedDisbursementOffice === 0 || c.disbursement_office_id === selectedDisbursementOffice;

      return matchCampaign && matchCreditStatus && matchGroup && matchCustomerType && matchDisbursementOffice;
    });

    const seen = new Set();
    const unique = [];

    filtered.forEach(item => {
      const identifier = item.id_customer;

      if (identifier && !seen.has(identifier)) {
        seen.add(identifier);
        unique.push(item);
      }
    });

    return unique;
  }, [customers, selectedCampaignId, selectedStatus, selectedGroup, selectedCustomerType, selectedDisbursementOffice]);

  const handleOpenCredit = (customerId, actionType) => {
    setAction(actionType);
    setOpenCredit(true);
    setCredit(credits.find((cred) => cred.customer_id === customerId) ?? customers.find((cust) => cust.id_customer === customerId));
  };

  const handleOpenForm = (customerId, actionType) => {
    setAction(actionType);
    setOpenForm(true);
    setCustomer(customers.find((cust) => cust.id_customer === customerId));
  };

  console.log(selectedStatus);


  return (
    <Box sx={{ p: { xs: 1, sm: 3 } }}>
      <FormCustomer open={openForm} setOpen={setOpenForm} action={action} customer={customer} />
      <Credit credit={credit} open={openCredit} onClose={() => setOpenCredit(false)} action={action} />

      {/* Botón de acción principal */}
      <Box sx={{ mb: 2 }}>
        <Button
          variant="outlined"
          startIcon={<AddReactionOutlinedIcon />}
          onClick={() => {
            setAction('createCustomer');
            setOpenForm(true);
          }}
          sx={{ height: 40, width: { xs: '100%', sm: 'auto' } }}
        >
          Nuevo Cliente
        </Button>
      </Box>

      {/* Filtros */}
      <Stack direction="row" spacing={2} mb={3} useFlexGap flexWrap="wrap">
        <FormControl sx={{ minWidth: { xs: '100%', sm: 180 } }} size="small">
          <InputLabel>Campaña</InputLabel>
          <Select
            value={selectedCampaignId}
            onChange={(e) => setSelectedCampaignId(e.target.value)}
            label="Campaña"
          >
            <MenuItem value={0}><em>Todas</em></MenuItem>
            {campaigns.map((camp) => (
              <MenuItem key={camp.id_campaign} value={camp.id_campaign}>{camp.name_campaign}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: { xs: '100%', sm: 180 } }} size="small">
          <InputLabel>Estado Cliente</InputLabel>
          <Select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            label="Estado Cliente"
          >
            <MenuItem value={0}><em>Todos</em></MenuItem>
            {status.map((st) => (
              <MenuItem key={st.id_type_data} value={st.id_type_data}>{st.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: { xs: '100%', sm: 180 } }} size="small">
          <InputLabel>Grupo</InputLabel>
          <Select
            value={selectedGroup}
            onChange={(e) => setSelectedGroup(e.target.value)}
            label="Grupo"
          >
            <MenuItem value={0}><em>Todos</em></MenuItem>
            {groups.map((gp) => (
              <MenuItem key={gp.id_customer_group} value={gp.id_customer_group}>{gp.group}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: { xs: '100%', sm: 180 } }} size="small">
          <InputLabel>Tipo de Cliente</InputLabel>
          <Select
            value={selectedCustomerType}
            onChange={(e) => setSelectedCustomerType(e.target.value)}
            label="Tipo de Cliente"
          >
            <MenuItem value={0}><em>Todos</em></MenuItem>
            {customerType.map((ct) => (
              <MenuItem key={ct.id_customer_type} value={ct.id_customer_type}>{ct.type_customer}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ minWidth: { xs: '100%', sm: 180 } }} size="small">
          <InputLabel>Pagaduria</InputLabel>
          <Select
            value={selectedDisbursementOffice}
            onChange={(e) => setSelectedDisbursementOffice(e.target.value)}
            label="Pagaduria"
          >
            <MenuItem value={0}><em>Todas</em></MenuItem>
            {disbursementOffice.map((df) => (
              <MenuItem key={df.id_disbursement_office} value={df.id_disbursement_office}>{df.disbursement_office}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>

      <CustomerTable rows={filteredCustomers} onOpenCredit={handleOpenCredit} onOpenForm={handleOpenForm} />
    </Box>
  );
};

export default Customer;